<template>
  <div>
    <NuxtLink :to="`/games/game/${id}`">
      <div
        v-if="props.master_slug.startsWith('lotto_thai')"
        class="col-span-1 md:col-span-3 lg:col-span-2 xl:grid-cols-5 border border-gray-200 rounded-md shadow hover:shadow-md"
      >
        <div
          class="p-2 d-flex items-center"
          :class="gameColorHeader(props.master_slug)"
        >
          <span class="text-md px-1 font-semibold">
            <nuxt-img
              :src="`/images/flags/${showFlag(props.master_slug)}`"
              class="h-6 w-auto drop-shadow-xs"
            />
          </span>
          <span class="text-sm px-2 font-semibold text-black"
            >{{ props.master_name }} {{ formatted }}</span
          >
        </div>
        <div
          class="flex flex-col divide-y divide-gray-300 justify-center"
          v-if="props.status == 'cancel'"
        >
          <div class="text-center bg-gray-100 p-3">
            <p class="text-md font-semibold p-2 text-red-900">ยกเลิกเกมส์</p>
          </div>
        </div>
        <div
          class="flex flex-col p-2 divide-y divide-gray-300 justify-center"
          v-else
        >
          <div class="text-center">
            <p class="text-sm text-gray-600 font-semibold">รางวัลที่ 1</p>
            <p class="text-md font-semibold text-green-800">
              {{ checkResults("6upper") }}
            </p>
          </div>
          <div class="grid grid-cols-3 divide-x divide-gray-300 pt-2">
            <div class="text-center">
              <p class="text-sm text-gray-600 font-semibold">สามตัวหน้า</p>
              <p class="text-md font-semibold text-green-800">
                {{ checkResults("3front_1") }} , {{ checkResults("3front_2") }}
              </p>
            </div>
            <div class="text-center">
              <p class="text-sm text-gray-600 font-semibold">สามตัวหลัง</p>
              <p class="text-md font-semibold text-green-800">
                {{ checkResults("3back_1") }} , {{ checkResults("3back_2") }}
              </p>
            </div>
            <div class="text-center">
              <p class="text-sm text-gray-600 font-semibold">สองตัวล่าง</p>
              <p class="text-md font-semibold text-green-800">
                {{ checkResults("2under") }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div
        v-else-if="props.master_slug.startsWith('step')"
        class="border border-gray-200 rounded-md shadow hover:shadow-md w-full"
      >
        <div
          class="p-2 d-flex items-center"
          :class="gameColorHeader(props.master_slug)"
        >
          <span class="text-md px-1 font-semibold">
            <nuxt-img
              :src="`/images/flags/${showFlag(props.master_slug)}`"
              class="h-6 w-auto drop-shadow-xs"
            />
          </span>
          <span class="text-sm px-1 font-semibold text-black"
            >{{ props.master_name }}
            {{
              props.master_slug.startsWith("yeekee")
                ? `รอบที่ ${props.round_no}`
                : `วันที่ ${formatted}`
            }}</span
          >
        </div>

        <div
          class="flex flex-col divide-y divide-gray-300 justify-center"
          v-if="props.status == 'cancel'"
        >
          <div class="text-center bg-gray-100 p-3">
            <p class="text-md font-semibold p-2 text-red-900">ยกเลิกเกมส์</p>
          </div>
        </div>
        <div v-else>
          <div class="grid grid-cols-1 p-2 divide-x divide-gray-200">
            <div class="text-center">
              <p class="text-sm text-gray-600 font-semibold">สี่ตัวบน</p>
              <p class="text-md font-semibold text-green-800">
                {{ checkResults("4upper") }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div
        v-else
        class="border border-gray-200 rounded-md shadow hover:shadow-md w-full"
      >
        <div
          class="p-2 d-flex items-center"
          :class="gameColorHeader(props.master_slug)"
        >
          <span class="text-md px-1 font-semibold">
            <nuxt-img
              :src="`/images/flags/${showFlag(props.master_slug)}`"
              class="h-6 w-auto drop-shadow-xs"
            />
          </span>
          <span class="text-sm px-1 font-semibold text-black"
            >{{ props.master_name }}
            {{
              props.master_slug.startsWith("yeekee")
                ? `รอบที่ ${props.round_no}`
                : `วันที่ ${formatted}`
            }}</span
          >
        </div>

        <div
          class="flex flex-col divide-y divide-gray-300 justify-center"
          v-if="props.status == 'cancel'"
        >
          <div class="text-center bg-gray-100 p-3">
            <p class="text-md font-semibold p-2 text-red-900">ยกเลิกเกมส์</p>
          </div>
        </div>
        <div v-else>
          <div class="grid grid-cols-2 p-2 divide-x divide-gray-200">
            <div class="text-center">
              <p class="text-sm text-gray-600 font-semibold">สามตัวบน</p>
              <p class="text-md font-semibold text-green-800">
                {{ checkResults("3upper") }}
              </p>
            </div>
            <div class="text-center">
              <p class="text-sm text-gray-600 font-semibold">สองตัวล่าง</p>
              <p class="text-md font-semibold text-green-800">
                {{ checkResults("2under") }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </NuxtLink>
  </div>
</template>
<script setup>
const { showFlag, gameColorHeader } = useUtils();
import { useArrayFindIndex, useArrayFind, useDateFormat } from "@vueuse/core";
const props = defineProps({
  id: String,
  master_id: String,
  master_slug: String,
  master_name: String,
  round_display: String,
  round: String,
  round_no: String,
  status: String,
  open_at: String,
  close_at: String,
  created_at: String,
  updated_at: String,
  secondDif: Number,
  results: Array,
});
const formatted = useDateFormat(props.round_display, "DD MMM YYYY", {
  locales: "th",
});

function resolveResults(slugSearch) {
  return new Promise((resolve) => {
    resolve(
      (data = useArrayFind(props.results, (val) => val.slug === slugSearch))
    );
  });
}

function checkResults(slugSearch) {
  const data = useArrayFind(props.results, (val) => val.slug === slugSearch);
  if (data.value) {
    return data.value.result;
  } else {
    return showStatus(props.status);
  }
}

function goto() {
  alert(11);
}

const showStatus = (value) => {
  let text;
  switch (value) {
    case "pending":
      // code block
      text = "ปิด";
      break;
    case "opened":
      // code block
      text = "เปิดรับ";
      break;
    case "closed":
      // code block
      text = "ปิดรับ";
      break;
    case "processing":
      // code block
      text = "คำนวณ";
      break;
    case "cancel":
      // code block
      text = "ยกเลิก";
      break;
    case "completed":
      // code block
      text = "ออกผล";
      break;
    default:
      text = "รอผล";
    // code block
  }

  return text;
};
</script>
